import * as React from 'react';
export default function PickerTag() {
  return React.createElement("div", {
    color: "blue"
  });
}